import Received from './received';

export default {
  Received,
};
